import {
  type StudentCollection,
  studentCollectionSchema,
  type Student,
  studentSchema, studentFilterSchema, type StudentFilter,
} from '@/types/Wiser/student.ts'

import { createRestApi, type HttpClient, type ModelApi } from '@jantm/model-core'

export type StudentApi = ModelApi<Student, StudentCollection, StudentFilter>

/**
 * The HTTP client is injected rather than imported so this package never pins
 * an axios instance, a base URL, or an auth interceptor — the host application
 * owns all three.
 */
export function createStudentApi(
  client: HttpClient,
  endpoint = '/wiser/cursist',
): StudentApi {
  return createRestApi({
    client,
    endpoint,
    schema: studentSchema,
    collectionSchema: studentCollectionSchema,
    filterSchema: studentFilterSchema,
  })
}
